import {Helmet} from '@dr.pogodin/react-helmet';
import {BreadcrumbType} from 'platform/components';
import {Box} from 'platform/foundation';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {DefinitionDetail} from './components/DefinitionDetail';

export function CashLimitsAdd() {
  const breadcrumbs: BreadcrumbType[] = [
    {
      label: i18n.t('page.accounting.labels.cashRegisterLimitsTitle'),
      href: settingsRoutes.cashLimits,
    },
  ];

  const title = i18n.t('page.accounting.labels.cashRegisterLimitsTitle');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate header={{breadcrumbs}} data-testid="settings-cashLimits-add">
        <Box maxWidth={206}>
          <DefinitionDetail />
        </Box>
      </SettingsTemplate>
    </>
  );
}
